// extracted by mini-css-extract-plugin
export default {"privacyOuter":"PrivacyPolicy_privacyOuter__MEH-K","titleSection":"PrivacyPolicy_titleSection__u6-Y1"};